import initialState from '../store/initial-state'
import { ASSET_RIGHTS_STATE_UPDATED } from '../constants/rights-constants'
import {
  ASSET_LAST_UPLOAD_GET_DATA,
  ASSET_LAST_UPLOAD_GET_DATA_SUCCESS,
  ASSET_LAST_UPLOAD_GET_DATA_FAILURE,
  ASSET_LAST_UPLOAD_EMPTY,
  ASSET_LAST_UPLOAD_ACTIVEVIEW,
  ASSET_LAST_UPLOAD_EDIT,
  ASSET_LAST_UPLOAD_EDIT_SUCCESS,
  ASSET_LAST_UPLOAD_EDIT_FAILURE,
  ASSET_LAST_UPLOAD_SET_SELECT,
  ASSET_LAST_UPLOAD_UNSET_SELECT,
  ASSET_LAST_UPLOAD_EDIT_SELECT,
  ASSET_LAST_UPLOAD_DELETE,
  ASSET_LAST_UPLOAD_DELETE_SUCCESS,
  ASSET_LAST_UPLOAD_DELETE_FAILURE,
  ASSET_LAST_UPLOAD_EDIT_UNSET_SELECT,
  ASSET_LAST_UPLOAD_EXPAND_SELECT,
  ASSET_LAST_UPLOAD_EXPAND_UNSET_SELECT,
  ASSET_LAST_UPLOAD_SHARE_SELECT,
  ASSET_LAST_UPLOAD_SHARE_UNSET_SELECT,
  ASSET_LAST_UPLOAD_MOVE,
  ASSET_LAST_UPLOAD_MOVE_SUCCESS,
  ASSET_LAST_UPLOAD_FAILURE,
  ASSET_LAST_UPLOAD_CHECK_SELECT,
  ASSET_LAST_UPLOAD_UNCHECK_SELECT,
  MULTIPLE_LAST_UPLOAD_OPTIONS_ACTIVATE,
  MULTIPLE_LAST_UPLOAD_OPTIONS_DEACTIVATE,
  MULTIPLE_LAST_UPLOAD_OPTIONS_DONE,
  ASSET_LAST_UPLOAD_UPDATE_FROM_PERMISSION,
  ASSETS_LAST_UPLOAD_MULTI_DELETE,
  ASSETS_LAST_UPLOAD_MULTI_DELETE_SUCCESS,
  ASSETS_LAST_UPLOAD_MULTI_DELETE_FAILURE,
  ASSETS_LAST_UPLOAD_MULTI_MOVE,
  ASSETS_LAST_UPLOAD_MULTI_MOVE_SUCCESS,
  ASSETS_LAST_UPLOAD_MULTI_MOVE_FAILURE
} from '../constants/assets-lastupload-types'

export default (state = initialState.assetsLastUploads, action) => {
  switch (action.type) {
    case ASSET_LAST_UPLOAD_GET_DATA:
      return {
        ...state,
        isFetching: action.payload.isFetching,
        data: action.payload.data,
        // isFetching: true,
        // data: [],
        headers: null,
        error: null
      }

    case ASSET_LAST_UPLOAD_GET_DATA_SUCCESS:
      return {
        ...state,
        folderselect: action.payload.folderselect,
        page: action.payload.page,
        isFetching: false,
        data: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? action.payload.data
          : action.payload.data.filter(r => r.group.length > 0),
        headers: action.payload.headers,
        error: null
      }

    case ASSET_LAST_UPLOAD_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: action.payload
      }

    case ASSET_LAST_UPLOAD_EMPTY:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: null
      }

    case ASSET_LAST_UPLOAD_SET_SELECT:
      const maxItems = action.payload.from === 'vertical'
        ? action.payload.verticalCount
        : action.payload.horizontalCount
      let exist = false
      let count = 0

      return {
        ...state,
        data: [...state.data.map((r, k) => {
          let i = k + 1
          if (count >= maxItems) {
            count = 1
            exist = false
          } else {
            count++
          }
          if (!exist) exist = `${action.payload.from}-${i}` === action.payload.indice
          return {
            ...r,
            drawMiddleView: (exist && maxItems === count) || (exist && i === state.data.length),
            isSelected: r._id === action.payload.data._id,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null
          }
        })]
      }

    case ASSET_LAST_UPLOAD_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            drawMiddleView: false,
            isSelected: false,
            isEditSelected: false,
            indice: null,
            from: null
          }
        })]
      }

    case ASSET_LAST_UPLOAD_ACTIVEVIEW:
      return {
        ...state,
        activeView: action.payload.activeView
      }

    case ASSET_LAST_UPLOAD_EDIT:
      return {
        ...state,
        isUpdating: true,
        headers: null,
        error: null
      }

    case ASSET_LAST_UPLOAD_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null,
            name: r._id === action.payload.data._id
              ? action.payload.data.name
              : r.name,
            metadata: {
              ...r.metadata,
              descriptiveTags: r._id === action.payload.data._id
                ? action.payload.data.metadata.descriptiveTags
                : r.metadata && r.metadata.descriptiveTags ? r.metadata.descriptiveTags : [],
              createdDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.createDate
                : r.metadata && r.metadata.createDate ? r.metadata.createDate : r.metadata && r.metadata.createdDate ? r.metadata.createdDate : null,
              dueDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.dueDate
                : r.metadata && r.metadata.dueDate ? r.metadata.dueDate : null,
            }
          }
        })]
      }

    case ASSET_RIGHTS_STATE_UPDATED: {
      const hasAsset = state.data.some(r => r._id === action.payload.assetId)
      if (!hasAsset) return state
      return {
        ...state,
        data: state.data.map(r =>
          r._id === action.payload.assetId
            ? {
                ...r,
                rightsState: action.payload.rightsState,
                metadata: {
                  ...r.metadata,
                  rightsStatus: action.payload.rightsStatus,
                  dueDate: action.payload.dueDate,
                  createdDate: action.payload.createdDate
                }
              }
            : r
        )
      }
    }

    case ASSET_LAST_UPLOAD_EDIT_FAILURE:
      return {
        ...state,
        isUpdating: false,
        headers: null,
        error: action.payload
      }

    case ASSET_LAST_UPLOAD_EDIT_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: r._id === action.payload.data._id,
          }
        })],
        editAssetTab: action.payload.editAssetTab
      }

    case ASSET_LAST_UPLOAD_EDIT_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: false,
          }
        })]
      }

    case ASSET_LAST_UPLOAD_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSET_LAST_UPLOAD_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case ASSET_LAST_UPLOAD_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }


    case ASSET_LAST_UPLOAD_EXPAND_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_LAST_UPLOAD_EXPAND_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: false,
          }
        })]
      }

    case ASSET_LAST_UPLOAD_SHARE_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_LAST_UPLOAD_SHARE_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: false,
          }
        })]
      }

    case ASSET_LAST_UPLOAD_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSET_LAST_UPLOAD_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_LAST_UPLOAD_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }

    case ASSET_LAST_UPLOAD_CHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = true : r.isCheckMultiple
          }
        })]
      }

    case ASSET_LAST_UPLOAD_UNCHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = false : r.isCheckMultiple
          }
        })]
      }

    case MULTIPLE_LAST_UPLOAD_OPTIONS_ACTIVATE:
      return {
        ...state,
        activateMultiOptions: true
      }
    case MULTIPLE_LAST_UPLOAD_OPTIONS_DEACTIVATE:
      return {
        ...state,
        activateMultiOptions: false
      }

    case MULTIPLE_LAST_UPLOAD_OPTIONS_DONE:
      return {
        ...state,
        activateMultiOptions: false,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: false
          }
        })]
      }

    case ASSET_LAST_UPLOAD_UPDATE_FROM_PERMISSION:
      return {
        ...state,
        data: [
          ...state.data.map(r => {
            return r._id === action.payload._id
              ? action.payload
              : { ...r }
          })
        ]
      }
    case ASSETS_LAST_UPLOAD_MULTI_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSETS_LAST_UPLOAD_MULTI_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => !action.payload.ids.includes(r._id))],
        error: null
      }

    case ASSETS_LAST_UPLOAD_MULTI_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }
    case ASSETS_LAST_UPLOAD_MULTI_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSETS_LAST_UPLOAD_MULTI_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: action.payload.ids.includes(r._id),
          }
        })]
      }

    case ASSETS_LAST_UPLOAD_MULTI_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }

    default: return { ...state }
  }
}
